<template>
  <!-- Recuadro del encargo online al final de un artículo del blog, ref: https://trello.com/c/VELGdumt
       Solo sale si el artículo tiene un trámite asociado en el panel y el encargo online está activo -->
  <div v-if="mostrar" class="blog-solicitud">
    <div class="blog-solicitud__cuerpo">
      <p v-if="nombreTramite" class="blog-solicitud__tramite">{{ nombreTramite }}</p>
      <p class="blog-solicitud__titulo">{{ t('¿Quiere hacer este encargo con nosotros?') }}</p>
      <p class="blog-solicitud__texto">{{ t('Envíenos sus datos y la documentación por internet y le contactaremos para prepararlo.') }}</p>
    </div>
    <NuxtLink class="blog-solicitud__boton" :to="acceso.enlace('blog', tramite)">
      {{ t('Hacerlo online') }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
import { t } from '../../composables/solicitudTextos'

const props = defineProps<{ tramite?: string | null }>()

const acceso = useAccesoSolicitud()
const { tipos, cargarCatalogo } = useSolicitudWeb()

const tramite = computed(() => String(props.tramite || '').trim() || null)
const mostrar = computed(() => acceso.activa.value && !!tramite.value)
/** Nombre del trámite en el idioma de la web (el catálogo ya viene traducido de la API). */
const nombreTramite = computed(() => tipos.value.find((x: any) => x.codigo === tramite.value)?.nombre ?? '')

onMounted(() => {
  if (mostrar.value) cargarCatalogo()
})
</script>

<style lang="scss">
.blog-solicitud {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px;
  margin-top: 40px; padding: 24px 28px; border-radius: 14px; background: #f5f7f9; border: 1px solid #e3e7ea;
  &__cuerpo { flex: 1 1 360px; min-width: 0; }
  &__tramite { margin: 0 0 4px; font-size: 0.8rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;
    color: rgb(var(--v-theme-primary)); }
  &__titulo { font-size: 1.15rem; font-weight: 600; margin: 0 0 4px; color: #1d2329; }
  &__texto { margin: 0; color: #5f6b76; }
  &__boton {
    display: inline-flex; align-items: center; min-height: 48px; padding: 0 26px; border-radius: 999px;
    background: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-on-primary)) !important;
    font-weight: 600; text-decoration: none !important; white-space: nowrap;
    &:hover, &:focus-visible { filter: brightness(1.08); }
  }
}
</style>
